import React from 'react';

import { Avatar, Loader } from '@lyearn/ui';
import { UserFragment } from '@/graphql/fragments/generated/User';

type Props = {
  fetching: boolean;
  user: UserFragment | undefined;
  selectedUserId: string | undefined;
};

const UserSearchAdornment = ({ fetching, user, selectedUserId }: Props) => {
  if (fetching) {
    return <Loader size={34} />;
  }

  if (selectedUserId) {
    return <Avatar size={34} src={user?.profilePicture ?? ''} />;
  }

  return null;
};

export default React.memo(UserSearchAdornment);
